module.exports = "{{ moment | veriDate: 'time' }} ";